import type { LangToggleProps, StepFlowLang } from '@/components/step-flow/StepFlowShell.types';
import { SegmentedControl, type SegmentedControlItem } from '@careflux/primitives';

const LANG_ITEMS: SegmentedControlItem[] = [
  { value: 'is', label: 'IS' },
  { value: 'en', label: 'EN' },
];

const isStepFlowLang = (value: string): value is StepFlowLang => value === 'is' || value === 'en';

export const LangToggle = ({ lang, onLangChange }: LangToggleProps) => (
  <SegmentedControl
    size="sm"
    aria-label={lang === 'is' ? 'Tungumál' : 'Language'}
    items={LANG_ITEMS}
    value={lang}
    onValueChange={(value) => {
      if (isStepFlowLang(value)) onLangChange(value);
    }}
  />
);
